import AddLeaveRequest from "../../../../components/company/performance/leave-request/AddLeaveRequest";

export default function AddLeaveRequestPage(){
    return <AddLeaveRequest />
}